import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Button, Modal } from 'react-bootstrap';
import LeaveForm from './LeaveForm';
import { getEmployeeLeaves } from '../../services/leaveServices';
const Leave = () => {
  const [showModal, setModal] = useState(false);
  const [remainingLeaves, setRemainingLeaves] = useState({});
  const [employeeId, setEmployeeId] = useState(null);

  const [appliedLeaves, setAppliedLeaves] = useState([]);

  const [totalLeaves, setTotalLeaves] = useState(0);

  const getLeave = async (id) => {
    try {
      const leaves = await getEmployeeLeaves(id);

      setAppliedLeaves(leaves?.leaves);
      setTotalLeaves(leaves?.totalLeaves);
      setRemainingLeaves(leaves?.remainingLeaves);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.id) {
      getLeave(user.id);
      setEmployeeId(user.id);
    }
  }, []);

  return (
    <div className="flex flex-col gap-y-3 w-full">
      <div className="flex justify-end">
        <Button className="gradient_one" onClick={() => setModal(true)}>
          Apply Leave
        </Button>
      </div>
      <ToastContainer />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="row">
                <div className="col-md-4 col-sm-12">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="flex flex-col justify-between text-base w-full">
                        <p className="font-semibold my-0 py-0">Total Applied Leaves: {totalLeaves}</p>
                        <p className="my-0 py-0 top-0">
                          <br />
                          <span>
                          </span>
                          <br />
                          <span>
                            <strong>Sick Leave:</strong> {remainingLeaves.Sick}
                          </span>
                          <br />
                          <span>
                            <strong>Paid Leave:</strong> {remainingLeaves.Paid}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-12">
                  <div className="card booking">
                    <div className="card-body">
                      <p className="fs-4 fw-bold">Applied Leave</p>
                      <table className="w-full">
                        <tr className="w-full flex flex-row justify-between">
                          <th className="w-full">Reason</th>
                          <th className="w-full">Type</th>

                          <th className="w-full">From Date</th>
                          <th className="w-full">To Date</th>
                          <th className="w-full">Status</th>
                        </tr>
                        <div className="no-scrollbar" style={{ maxHeight: '12rem', overflowY: 'auto' }}>
                          {appliedLeaves.length > 0 ? (
                            appliedLeaves.map((leave, i) => (
                              <tr className="w-full flex flex-row justify-between my-4 items-center" key={i}>
                                <td className="w-full">{leave?.reason}</td>
                                <td className="w-full">{leave?.type}</td>
                                <td className="w-full">{new Date(leave?.startDate).toLocaleDateString()}</td>
                                <td className="w-full">{new Date(leave?.endDate).toLocaleDateString()}</td>
                                <td
                                  className={`w-full ${
                                    leave.status === 'Approved'
                                      ? 'bg-green-700'
                                      : leave.status === 'Declined'
                                      ? 'bg-red-700'
                                      : 'bg-gray-700'
                                  } px-3 py-2 rounded-full text-center text-white`}
                                >
                                  {leave?.status}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <div className="text-center text-gray-500 py-4">No applied leave</div>
                          )}
                        </div>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={() => setModal(false)} centered>
          <LeaveForm
            onCancel={() => setModal(false)}
            leaves={remainingLeaves}
            getLeave={getLeave}
            employeeId={employeeId}
          />
        </Modal>
      </div>
    </div>
  );
};

export default Leave;


